import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotificationContext } from '../../providers/NotificationProvider';
import { DashboardSection } from '../../components/DashboardSection/DashboardSection';
import { ProjectDetailsCard } from '../../components/Card/ProjectDetailsCard/ProjectDetailsCard';
import { EntitlementStatusCard } from '../../components/Card/EntitlementStatusCard/EntitlementStatusCard';
import { SourcesCard } from '../../components/Card/SourcesCard/SourcesCard';
import { MigrationStatusCard } from '../../components/Card/MigrationStatusCard/MigrationStatusCard';
import { LandingZonesCard } from '../../components/Card/LandingZonesCard/LandingZonesCard';
import { MoveGroupStatusCard } from '../../components/Card/MoveGroupStatusCard/MoveGroupStatusCard';
import { getSessionVar, formatDate } from '../../lib/helpers';
import { ROUTE_CONFIG } from '../../constants/routes';
import { UserRoles } from '../../constants/index';
import './NewMigrationDashboard.scss';

// WIP - needs confirmation
const calculateProjectWeeks = (startDate, endDate) => {
    if (!startDate || !endDate) return { current: null, total: null };
    const start = new Date(startDate);
    const end = new Date(endDate);
    const now = new Date();
    const msPerWeek = 7 * 24 * 60 * 60 * 1000;
    const total = Math.max(1, Math.ceil((end - start) / msPerWeek));
    const elapsed = Math.ceil((now - start) / msPerWeek);
    const current = Math.min(Math.max(1, elapsed), total);
    return { current, total };
};

export const NewMigrationDashboard = ({ newMigrationData, getUserRole }) => {
    const navigate = useNavigate();
    const { notifyError } = useNotificationContext();
    const currentOrg = getSessionVar('currentOrg') || {};
    const isGlobalAdmin = getUserRole() === UserRoles.GLOBAL_ADMIN;
    const isAdmin = getUserRole() === UserRoles.ADMIN || getUserRole() === UserRoles.ORG_ADMIN;

    const { current: currentWeek, total: totalWeeks } = calculateProjectWeeks(
        currentOrg.project_start_date,
        currentOrg.project_end_date,
    );

    const handleCardClick = (link) => {
        if (isGlobalAdmin) {
            return;
        }

        if (link === ROUTE_CONFIG.projects.path && isAdmin) {
            navigate(link);
        } else if (link === ROUTE_CONFIG.projects.path && !isAdmin) {
            notifyError({ description: 'You do not have permission to access this page.' });
        } else {
            navigate(link);
        }
    };

    return (
        <DashboardSection title="Migration" className="new-migration-dashboard">
            <div className="new-migration-dashboard-content">
                <ProjectDetailsCard
                    projectName={currentOrg.name}
                    currentWeek={currentWeek}
                    totalWeeks={totalWeeks}
                    status={currentOrg.project_state}
                    startDate={formatDate(currentOrg.project_start_date)}
                    endDate={formatDate(currentOrg.project_end_date)}
                    owner={currentOrg.project_owner}
                    costCenter={currentOrg.project_cost_center}
                    onManageClick={handleCardClick}
                />
                <EntitlementStatusCard newMigrationData={newMigrationData} isAdmin={isAdmin} />
                <SourcesCard sources={newMigrationData.sources} handleCardClick={handleCardClick} />
                <MigrationStatusCard migrationData={newMigrationData.migrationStatus} />
                <LandingZonesCard />
                {/* <MoveGroupStatusCard /> */}
            </div>
        </DashboardSection>
    );
};
